import React, { useEffect } from "react";
import { Link } from "react-router-dom";
import "./NotFound.css"

/* export const PageNotFound = () => {
  return (
    <div
      className="d-flex align-items-center justify-content-center bg-light"
      style={{ minHeight: "100vh" }}
    >
      <div
        className=" text-center"
        style={{ maxWidth: "600px", width: "100%" }}
      >
        <div className="mb-3">
          <Link to={"/"}>
          <img src="https://d2lvj32mp5x83n.cloudfront.net/static/logo-YQ/YQLogoPlainBig.png" alt="YQ"/>
          </Link>        </div>
        <h4 className="NotFoundSctnheading mb-3 mt-4">404 - Page Not Found</h4>
        <p className="NotFoundSctnpara mb-4">
          Sorry, the page you are looking for does not exist.
        </p>
        <Link to="/" className="btn btn-outline-primary w-100 bg-primary text-white">
          Go Back to Home
        </Link>
      </div>
    </div>
  );
}; */

export const PageNotFound = () => {
  useEffect(() => {
    // Set canonical URL to homepage for ALL 404 pages
    let canonical = document.querySelector('link[rel="canonical"]');
    if (!canonical) {
      canonical = document.createElement('link');
      canonical.rel = 'canonical';
      document.head.appendChild(canonical);
    }
    canonical.href = window.location.origin;
    
    const metaRobots = document.querySelector('meta[name="robots"]');
    if (metaRobots) {
      metaRobots.content = 'noindex, nofollow, noarchive, nosnippet, noimageindex';
    } else {
      const newMeta = document.createElement('meta');
      newMeta.name = 'robots';
      newMeta.content = 'noindex, nofollow, noarchive, nosnippet, noimageindex';
      document.head.appendChild(newMeta);
    }

    const metaGooglebot = document.createElement('meta');
    metaGooglebot.name = 'googlebot';
    metaGooglebot.content = 'noindex, nofollow, noarchive, nosnippet, noimageindex';
    document.head.appendChild(metaGooglebot);
  }, []);

  return (
    <div
      className="d-flex align-items-center justify-content-center bg-light"
      style={{ minHeight: "100vh" }}
    >
      {/* Hidden meta tags for SEO protection */}
      <meta name="robots" content="noindex, nofollow, noarchive, nosnippet, noimageindex" />
      <meta name="googlebot" content="noindex, nofollow, noarchive, nosnippet, noimageindex" />
      
      <div
        className="text-center"
        style={{ maxWidth: "600px", width: "100%" }}
      >
        <div className="mb-3">
          <Link to={"/"}>
            <img 
              src="https://d2lvj32mp5x83n.cloudfront.net/static/logo-YQ/YQLogoPlainBig.png" 
              alt="YQ"
            />
          </Link>
        </div>
        <h4 className="NotFoundSctnheading mb-3 mt-4">404 - Page Not Found</h4>
        <p className="NotFoundSctnpara mb-4">
          Sorry, the page you are looking for does not exist.
        </p>
        <Link to="/" className="btn btn-outline-primary w-100 bg-primary text-white">
          Go Back to Home
        </Link>
      </div>
    </div>
  );
};